import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { PushApi } from 'api';
import { IPushMessage, SearchPushFilterType } from 'types';
import { KEY } from './keys';

function useGetInfinite(filter: SearchPushFilterType, size = 30) {
  return useAuthInfiniteList<IPushMessage>(
    [...getQueryKeys([KEY]).lists(), 'infinite', { ...filter, size }],
    (page) => PushApi.getAll({ ...filter, page, size }),
  );
}

export default useGetInfinite;
